import { finectAPI } from '@finect/front-utils/finectAPI';
var getEndpoint = function getEndpoint(versus, product) {
  if (versus === 'managementCompany') {
    return "products/collectives/funds?filter=managementCompany/id+eq+'".concat(product.managementCompany.id, "'&expand=classes,stats/performance&limit=50");
  } else if (versus === 'category') {
    return "products/collectives/funds?filter=category/id+eq+'".concat(product.category.id, "'&expand=classes,stats/performance&limit=50");
  }
  return null;
};
export var fetchFunds = function fetchFunds(versus, product) {
  return finectAPI({
    version: 'v4',
    path: getEndpoint(versus, product),
    method: 'GET',
    onSuccess: function onSuccess(_ref) {
      var data = _ref.data;
      return data;
    }
  });
};